export default "__VITE_ASSET__BWqLI0Wg__"